<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                  <FormSection title="">
                      <AmountSelectorSimple />                    
                      <ErrorLabel field="amount" />
                  </FormSection>
                  <FormSection title="Your Details">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>
                      <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
                  </FormSection>                
                  <FormSection title="Billing Information" >
                      <DonorAddress />
                  </FormSection>
                  <FormSection title="Payment Information" last>
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false" />
                      </FormRow>
                   </FormSection>
                  <PaymentButton btnText="Donate"/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>

  <script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup(props) {
    const { setValue, form, submit } = usePaymentForm()
    setValue('description', 'JLIC Depoist charges')

    return {
      form,
      submit,
    }
  },
})
</script>

  <style scoped lang="scss">
  h2.payment-heading {
    display: flex;
    justify-content: space-between;
  }
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .fee-total {
    margin-bottom: 0;
    justify-content: space-between;
  }
  </style>
  
  